module.exports = __webpack_public_path__ + "static/img/icon2.9e0d11d8.png";